import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";

const ProcessPassedModal = ({
  showPopup,
  isGuarantor,
  heading,
  subheading,
  buttonText,
  handleClick,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      {showPopup && (
        <div
          className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
            isGuarantor ? "guarantorBg" : ""
          }`}
          style={{ zIndex: 9999 }}
        >
          <div className="popup-content2 popup-content bg-white kycDonePopup">
            <div className="row relativeposition custom-mb-5">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
                <div className="authenticateid-header text-center">
                  <h4>{heading}</h4>
                  <p>{subheading}</p>
                </div>
              </div>
            </div>
            <div className="text-center py-3 custom-mb-5">
              <div className="animate-slow-bounce">
                <div class="circle-container tick-circle">
                  <svg
                    class="tick-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="3.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <button
                type="button"
                onClick={handleClick}
                className="addGuarantorButton custom-mb-4 greenHover doneButton"
              >
                {haveValue(buttonText) ? _t(buttonText) : _t("done&GoBack")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProcessPassedModal;
